// extracted by mini-css-extract-plugin
module.exports = {"obfuscated":"utils-module--obfuscated--3z_kh"};